import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] as const } },
};

const stagger = {
  visible: { transition: { staggerChildren: 0.1 } },
};

// Cores das resinas são constantes de produto (não tokens de tema).
// Verde Escuro, Verde, Tijolo e Cinza compartilham o mesmo hex entre as linhas (mesma tinta-base);
// Azul Escuro (tênis) e Azul (poli) também compartilham #1f3d72. A ORDEM de cada array é intencional.
const RESIN_COLORS = {
  tenis: [
    { name: "Verde Escuro", hex: "#1d5638" },
    { name: "Verde", hex: "#2f8a52" },
    { name: "Azul Escuro", hex: "#1f3d72" },
    { name: "Azul Claro", hex: "#2f6db0" },
    { name: "Tijolo", hex: "#b14a30" },
    { name: "Cinza", hex: "#6b7178" },
    { name: "Violeta", hex: "#5f4a9c" },
  ],
  poli: [
    { name: "Verde Escuro", hex: "#1d5638" },
    { name: "Verde", hex: "#2f8a52" },
    { name: "Azul", hex: "#1f3d72" },
    { name: "Amarela", hex: "#e3aa2c" },
    { name: "Tijolo", hex: "#b14a30" },
    { name: "Cinza", hex: "#6b7178" },
  ],
};

const lines = [
  { title: "Linha Tênis", code: "TN-", colors: RESIN_COLORS.tenis },
  { title: "Linha Poliesportiva", code: "PL-", colors: RESIN_COLORS.poli },
];

const CartelaCores = () => (
  <section className="bg-surface-muted py-[76px]">
    <div className="container max-w-[1120px]">
      <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} variants={stagger}>
        {/* Header */}
        <motion.div variants={fadeUp} className="mb-12 max-w-[760px]">
          <span className="inline-block font-mono text-[0.72rem] uppercase tracking-[0.22em] text-accent">
            Resinas Acrílicas · Cores
          </span>
          <h2 className="mt-[14px] text-[1.7rem] font-extrabold leading-[1.08] tracking-[-0.045em] md:text-[2.3rem]">
            Cores disponíveis por linha.
          </h2>
          <p className="mt-4 max-w-[56ch] leading-relaxed text-muted-foreground">
            Cada linha de resina acrílica tem sua cartela própria. As cores são ilustrativas — a referência final é a carta de cores física.
          </p>
        </motion.div>

        {/* Cartelas */}
        {lines.map((line, li) => (
          <motion.div key={line.title} variants={fadeUp} className={li > 0 ? "mt-[42px]" : ""}>
            <div className="mb-[22px] flex items-baseline gap-[14px] border-b-2 border-foreground pb-3">
              <h3 className="text-[1.15rem] font-extrabold tracking-[-0.02em]">{line.title}</h3>
              <span className="font-mono text-[0.66rem] uppercase tracking-[0.12em] text-muted-foreground">
                {line.colors.length} cores
              </span>
            </div>
            <div className="grid grid-cols-3 gap-[14px] min-[560px]:grid-cols-4 min-[1000px]:grid-cols-7">
              {line.colors.map((c, i) => (
                <div key={c.name}>
                  <div
                    className="relative aspect-[4/5] overflow-hidden rounded-[4px] shadow-[inset_0_0_0_1px_rgba(0,0,0,0.14)]"
                    style={{ background: c.hex }}
                  >
                    <span className="absolute left-[14%] right-[14%] top-1/2 h-[2px] -translate-y-px bg-white/[0.62]" />
                  </div>
                  <div className="mt-[10px] flex flex-col gap-0.5">
                    <span className="text-[0.82rem] font-bold leading-[1.2]">{c.name}</span>
                    <span className="font-mono text-[0.62rem] tracking-[0.1em] text-muted-foreground">
                      {line.code}{String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default CartelaCores;
